import React from "react"
import { PrivateRoute } from "./components/private_route"
import PersonalDashboard from "./pages/personal_dashboard"
import SignUp from "./pages/sign_up"
import SignIn from "./pages/sign_in"
import ForgotPassword from "./pages/forgot_password"
import ResetPassword from "./pages/reset_password"
import VerifyEmail from "./pages/verify_email"
import TeamDashboard from "./pages/team_dashboard"
import AcceptInvite from "./pages/accept_invite"
import Settings from "./pages/settings"
import SignUpConfirmation from "./pages/sign_up_confirmation"
import AddProjects from "./pages/add_projects"
import InviteYourTeam from "./pages/invite_your_team"
import NameAndPassword from "./pages/name_and_password"
import TutorialPage from "./pages/tutorial_page"
import OAuthAuthorization from "./pages/oauth_authorization"

export const isPathShowBodyOnlyPage = (pathname) => {
    const pageName = Object.keys(pages).find(key => pages[key].path === pathname)
    const page = pages[pageName]
    return page && page.pageBodyOnly
}

const pages = {
    home: {
        path: "/",
        name: "signIn",
        component: SignIn,
        title: "Sign In | Shoutbase",
        open: true,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    oauthAuthorization: {
        path: "/oauth/authorization",
        name: "oauthAuthorization",
        component: OAuthAuthorization,
        title: "Authorization | Shoutbase",
        open: false,
        allowRedirect: true,
        pageBodyOnly: true,
    },

    acceptInvite: {
        path: "/acceptInvite",
        name: "acceptInvite",
        component: AcceptInvite,
        section: "",
        title: "Welcome | Shoutbase",
        open: true,
        noRedirect: true,
        transitions: ["home", "signUp", "signUp", "dashboard"],
        allowRedirect: false,
        pageBodyOnly: false,
    },

    verifyEmail: {
        path: "/verifyEmail",
        name: "verifyEmail",
        component: VerifyEmail,
        open: true,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    personalDashboard: {
        path: "/dashboard",
        name: "personalDashboard",
        component: PersonalDashboard,
        title: "Dashboard | Shoutbase",
        open: false,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    teamDashboard: {
        path: "/teams/:teamId",
        name: "teamDashboard",
        component: TeamDashboard,
        title: "Teams | Shoutbase",
        open: false,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    signUp: {
        path: "/signUp",
        name: "signUp",
        component: SignUp,
        title: "Sign Up | Shoutbase",
        open: true,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    login: {
        path: "/signIn",
        name: "signIn",
        component: SignIn,
        title: "Sign In | Shoutbase",
        open: true,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    forgotPassword: {
        path: "/forgotPassword",
        name: "forgotPassword",
        component: ForgotPassword,
        title: "Forgot Password | Shoutbase",
        open: true,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    resetPassword: {
        path: "/resetPassword",
        name: "resetPassword",
        component: ResetPassword,
        title: "Reset your Shoutabase Password",
        open: true,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    accountOverview: {
        path: "/settings",
        name: "settings",
        component: Settings,
        title: "Settings",
        open: false,
        allowRedirect: true,
        pageBodyOnly: false,
    },

    signUpConfirmation: {
        path: "/signUpConfirmation",
        name: "signUpConfirmation",
        component: SignUpConfirmation,
        title: "Sign Up Confirmation",
        open: false,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    addProjects: {
        path: "/addProjects",
        name: "addProjects",
        component: AddProjects,
        title: "Add Projects",
        open: false,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    inviteYourTeam: {
        path: "/inviteYourTeam",
        name: "inviteYourTeam",
        component: InviteYourTeam,
        title: "Invite Your Team",
        open: false,
        allowRedirect: false,
        pageBodyOnly: false,
    },

    nameAndPassword: {
        path: "/nameAndPassword",
        name: "nameAndPassword",
        component: NameAndPassword,
        title: "Name And Password",
        open: false,
        allowRedirect: false,
        pageBodyOnly: false,
    },
    tutorial: {
        path: "/tutorial",
        name: "tutorial",
        component: TutorialPage,
        title: "How Shoutbase Works",
        open: false,
        allowRedirect: false,
        pageBodyOnly: false,
    },
}

function pathFor(pageKey) {
    return pages[pageKey].path
}

function buildProps(pageKey) {
    const { path, ...props } = pages[pageKey] // eslint-disable-line no-unused-vars
    return Object.assign({}, props)
}

function routes(parentPath = "", passProps = {}, onboardingStep) {
    return Object.keys(pages).map(pageKey => {
        const { component, path } = pages[pageKey]
        const pageProps = buildProps(pageKey)
        const truePath = parentPath + path
        return (
            <PrivateRoute
                exact
                path={truePath}
                component={component}
                key={truePath}
                passProps={passProps}
                onboardingStep={onboardingStep}
                {...pageProps}
            />
        )
    })
}

export { buildProps, pages, pathFor, routes }



// WEBPACK FOOTER //
// ./src/app_map.js